import { actionCopyEs } from "./actionCopy";
import { listCopyEs } from "./listCopy";

export const patientsCopyEs = {
    patients: "Pacientes",
    navPatientsDescription: "Gestione todos sus pacientes en un único lugar.",
    patientFallback: "Paciente",
    action: "Acción",
    trackerEntry: "Registro de seguimiento",
    patientsError: "Error de pacientes",
    error: "Error",
    tabActive: "Activos",
    tabPending: "En espera",
    tabInactive: "Inactivos",
    search: actionCopyEs.search,
    searchPatientsAria: "Buscar pacientes",
    searchForPatient: "Buscar un paciente",
    searchDescription:
        "Busque por nombre, correo electrónico, fecha de nacimiento, número de historia clínica o nombre del diario",
    searchPlaceholder: "Buscar por nombre, correo electrónico, fecha de nacimiento, número de historia...",
    noResultsFound: "Ningún resultado",
    trySearchingHint:
        "Pruebe a buscar por nombre, correo electrónico, fecha de nacimiento o número de historia clínica",
    enterSearchTerm: "Indique un término de búsqueda para encontrar pacientes",
    loadingDiaries: "Cargando los diarios...",
    errorLoadingDiaries: (message) => `Error al cargar los diarios: ${message}`,
    unknownPatient: "Paciente desconocido",
    dateOfBirthLabel: "Fecha de nacimiento",
    noDiariesOnPage: "Ningún diario en esta página",
    showingDiaries: (start, end, total) => `Diarios del ${start} al ${end} de ${total}`,
    patientsPerPage: "Pacientes por página",
    emptyFirstPatientTitle: "Invite a su primer paciente",
    emptyFirstPatientDescription:
        "Elija una configuración de diario, verifique los datos y luego envíe una invitación. Su evolución aparecerá aquí.",
    emptyFirstPatientCta: "Añadir su primer diario",
    emptyFirstPatientHelpLink: "¿Cómo invitar a un paciente?",
    emptyTabTitle: (tabLabel) => `Ningún diario ${tabLabel.toLowerCase()}`,
    emptyTabDescription:
        "Los diarios de las otras pestañas siguen disponibles. Cambie de pestaña, o invite a otro paciente.",
    notDefined: "No definido",
    columnDiaryStatus: "Estado del diario",
    columnStartDate: "Fecha de inicio",
    columnPatientName: "Nombre del paciente",
    columnOrganisation: listCopyEs.organisation,
    columnLabels: listCopyEs.labels,
    columnDateOfBirth: listCopyEs.dateOfBirth,
    columnHospitalNumber: "Número de historia clínica",
    columnRead: "Revisado",
    filters: actionCopyEs.filters,
    filterDiariesAria: "Filtrar los diarios",
    viewSettings: "Ajustes de visualización",
    viewSettingsDescription:
        "Elija el ámbito de los diarios, el estado, los clínicos con los que se comparten, las etiquetas y los filtros de organización para esta lista.",
    sharedWithClinicians: "Compartido con clínicos",
    diaryStatus: "Estado del diario",
    selectStatuses: "Seleccionar estados",
    labels: listCopyEs.labels,
    organisation: listCopyEs.organisation,
    save: actionCopyEs.save,
    apply: actionCopyEs.apply,
    sortDiariesTitle: "Ordenar los diarios",
    sortDiariesDescription:
        "Elija el campo y el orden para esta lista. La ordenación se aplica a todos los diarios de la pestaña actual, no solo a esta página.",
    diaryScope: "Ámbito de los diarios",
    directAccess: "Acceso directo",
    allDiariesInOrganisation: "Todos los diarios de mi organización",
    selectClinicians: "Seleccionar clínicos",
    selectLabels: "Seleccionar etiquetas",
    clearFilters: "Borrar filtros",
    selectOrganisations: "Seleccionar organizaciones",
    sortDiariesAria: "Ordenar los diarios",
    sortBy: "Ordenar por",
    order: "Orden",
    sortAscending: "Ascendente",
    sortDescending: "Descendente",
    sortState: "Estado",
    sortStartDate: "Fecha de inicio",
    sortFirstName: "Nombre",
    sortLastName: "Apellidos",
    sortDateOfBirth: "Fecha de nacimiento",
    sortHospitalNumber: "Número de historia clínica",
    read: "Revisado",
    unread: "No revisado",
    noDiarySelected: "Ningún diario seleccionado",
    refreshDiary: "Actualizar el diario",
    noDiaryFound: "No se ha encontrado ningún diario.",
    diaryCouldNotLoad: "No se ha podido cargar el diario.",
    profileCouldNotLoad: "No se ha podido cargar el perfil.",
    diaryDetails: "Detalles del diario",
    patientDetails: "Datos del paciente",
    unknownState: "Estado desconocido",
    edit: actionCopyEs.edit,
    done: actionCopyEs.done,
    none: actionCopyEs.none,
    contact: "Contacto",
    noContactPerson: "Ninguna persona de contacto",
    lastEntry: (relative) => `Último registro ${relative}`,
    diaryOrganisation: "Organización del diario",
    organisationAndContact: "Organización y contacto",
    editCareDetails: "Modificar los datos de la atención",
    labelsStudyTrial: "Etiquetas (estudio / ensayo)",
    contactName: "Nombre del contacto",
    contactLabel: (name) => `Contacto: ${name}`,
    nameLabel: "Nombre",
    emailLabel: "Correo electrónico",
    openLink: "Abrir el enlace",
    dateRangeToNow: (start) => `${start} hasta hoy`,
    dateRangeTo: (start, end) => `${start} al ${end}`,
    informationToComplete: "Información por completar",
    clinicianTasks: (entryCount, formCount) =>
        `Tiene ${entryCount === 1 ? "1 registro por completar" : `${entryCount} registros por completar`} en ${
            formCount === 1
                ? "1 formulario que el equipo debe completar."
                : `${formCount} formularios que el equipo debe completar.`
        }`,
    completeNextForm: "Completar el siguiente formulario",
    completeForm: (title) => `Completar ${title}`,
    questionnaire: "Cuestionario",
    more: actionCopyEs.more,
    moreActions: "Más acciones",
    moreActionsAria: "Más acciones",
    printDiary: "Imprimir el diario",
    shareDiary: "Compartir el diario",
    openFullScreen: "Abrir a pantalla completa",
    messageHistory: "Historial de mensajes",
    deleteDiary: "Eliminar el diario",
    deleteDiaryTitle: "Eliminar el diario",
    deleteDiaryDescription: "¿Desea eliminar este diario?",
    cancel: actionCopyEs.cancel,
    delete: actionCopyEs.delete,
    updateDiary: "Actualizar el diario",
    addToDiary: "Añadir al diario",
    addEvent: "Añadir un evento",
    addConsent: "Añadir un consentimiento",
    addQuestionnaire: "Añadir un cuestionario",
    addFromTemplate: "Añadir desde un modelo",
    addEventDescription: "Añada una intervención y asóciela a una fecha existente, o cree una nueva.",
    addConsentDescription: "Asocie un consentimiento a una intervención, o añada uno con su propia fecha.",
    addQuestionnaireDescription: "Añada un cuestionario y asócielo a una fecha existente, o cree una nueva.",
    addFromTemplateDescription: "Aplique un modelo guardado a este diario.",
    addConsentTitle: "Añadir un consentimiento",
    addConsentDescriptionLong: "Elija una intervención, o añada un consentimiento con su propia fecha.",
    selectProcedureDate: "Intervención",
    notForAnEvent: "Sin vinculación a un evento",
    consentDate: "Fecha",
    noProcedureDatesForConsent: "Añada primero una intervención.",
    addEventFirst: "Añada primero un evento",
    selectConsent: "Consentimiento",
    selectConsentHelp: "Elija un consentimiento publicado para añadirlo a este diario.",
    noPublishedConsents:
        "No hay ningún consentimiento publicado disponible. Un administrador puede publicar uno en el generador de consentimientos.",
    consentRoles: "Quién debe firmar",
    consentRolesHelp: "Las personas seleccionadas serán invitadas a firmar este consentimiento.",
    saveConsent: "Añadir el consentimiento",
    savingConsent: "Añadiendo el consentimiento…",
    existingDateGroup: "Ocurrió en la misma fecha que",
    newDate: "Ninguna de las fechas anteriores",
    newDateHelp: "",
    pickExistingDateHelp: "",
    markAsReviewed: "Marcar como revisado",
    endDiary: "Cerrar el diario",
    reinstate: "Reactivar",
    contactPatient: "Contactar al paciente",
    endDiaryTitle: "Cerrar el diario",
    endDiaryNotifyQuestion: "¿Desea informar al paciente?",
    justEndDiary: "Cerrar sin avisar",
    endDiaryAndNotify: "Cerrar y avisar al paciente",
    markReviewedTitle: "Marcar como revisado",
    markReviewedNotifyQuestion: "¿Desea informar al paciente de que su diario ha sido revisado?",
    justMarkReviewed: "Marcar como revisado sin avisar",
    notifyPatient: "Avisar al paciente",
    from: "De",
    to: "Para",
    subject: "Asunto",
    emailBody: "Cuerpo del correo",
    send: actionCopyEs.send,
    sending: actionCopyEs.sending,
    emailSentSuccess: "Correo enviado correctamente",
    emailSentDescription: "Se ha avisado al paciente",
    emailSendFailed: "No se ha podido enviar el correo",
    seeYourPatients: "Ver sus pacientes",
    seeYourPatientsDescription: "Siga la evolución de sus pacientes y gestione sus diarios",
    goToPatients: "Ir a pacientes",
    goingToPatients: "Redirigiendo a pacientes...",
    reliableEmailWarning: "Para una entrega fiable, recomendamos Gmail, Outlook o iCloud.",
    entryRecordedTitle: "Registro guardado correctamente",
    entryRecordedPending: (count) =>
        `Quedan ${count} ${count === 1 ? "registro pendiente" : "registros pendientes"} para este paciente. Asegúrese de que se completen todas las valoraciones requeridas.`,
    entryRecordedComplete:
        "Se han completado todos los registros requeridos para este paciente. La historia clínica del paciente está ahora actualizada.",
    continueToNextEntry: "Pasar al siguiente registro",
    returnToPatient: "Volver al paciente",
    loadingTemplates: "Cargando los modelos…",
    addToDiaryTitle: "Añadir al diario",
    addToDiaryDescription: "Añada una intervención, un consentimiento o un cuestionario, o empiece desde un modelo.",
    addManually: "Añadir manualmente",
    addManuallyDescription: "Indique paso a paso los datos de la intervención y del cuestionario, sin usar un modelo.",
    chooseTemplate: "Elegir un modelo",
    chooseTemplateDescription:
        "Seleccione un modelo guardado para rellenar los datos de la intervención y del cuestionario de este diario.",
    reviewTemplate: "Verificar el modelo",
    reviewTemplateDescription: "Confirme los siguientes datos antes de añadirlos a este diario.",
    confirmAndContinue: "Confirmar y continuar",
    notifyPatientTitle: "¿Avisar al paciente?",
    intervention: "Intervención",
    openingTemplateProcedure: "Abriendo la intervención del modelo…",
    existingQuestionnaires: "Cuestionarios existentes",
    continueWithAllQuestionnaires: "Continuar con todos los cuestionarios",
    upcomingEntries: "Próximos registros",
    noUpcomingEntries: "No hay próximos registros.",
    moreEntriesSummary: (count) => `... ${count} registros más ...`,
    unlocks: (date) => `Desbloqueado el ${date}`,
    diaryEnded: "Diario cerrado",
    failedToEndDiary: "No se ha podido cerrar el diario",
    tableSettingsSaved: "Ajustes de la tabla guardados",
    diaryAlreadyRead: "Diario ya leído",
    diaryReviewedSubject: "Diario revisado",
    newDiary: "Nuevo diario",
    searchTemplatesPlaceholder: "Buscar por intervención, área o cuestionario...",
    noTemplatesYet: "Aún no tiene un modelo. Cree uno para empezar a invitar pacientes.",
    noTemplatesMatch: "Ningún modelo coincide con su búsqueda.",
    searchTemplatesShort: "Buscar modelos...",
    procedureFilterInjection: "Inyección",
    procedureFilterSurgery: "Cirugía",
    procedureFilterShockwave: "Ondas de choque",
    procedureFilterConsultation: "Consulta",
    procedureFilterProduct: "Producto",
    checkingActiveQuestionnaires: "Buscando cuestionarios activos...",
    stopQuestionnairesDescription:
        "Detenga los cuestionarios en curso antes de añadir uno nuevo, o continúe con todos los cuestionarios activos.",
    noActiveQuestionnairesDescription: "No hay ningún cuestionario activo. Continúe para añadir uno nuevo.",
    stopping: "Deteniendo...",
    stopAllCurrentQuestionnaires: "Detener todos los cuestionarios en curso",
    stopOnly: (name) => `Detener solo ${name}`,
    stopJoined: (list) => `Detener ${list}`,
    stopTrackerAria: (name) => `Detener ${name}`,
    checkingActiveBeforeTemplate: "Buscando cuestionarios activos antes de confirmar el modelo…",
    templateExistingTrackersDescription:
        "Seleccione los que desea detener antes de añadir desde este modelo, o continúe con todos los cuestionarios activos.",
    newPatientDiary: "Nuevo diario de paciente",
    newPatientDiaryDescription: "Elija un modelo, verifique la configuración y luego invite a su paciente.",
    createTemplate: "Crear un modelo",
    favourites: "Favoritos",
    allTemplates: "Todos los modelos",
    needFiltersHint: "¿Necesita filtros o gestionar los modelos?",
    browseAllTemplates: "Explorar todos los modelos",
    cc: "Cc",
    saving: "Guardando…",
    interventionTypeQuestion: "¿Qué tipo de intervención?",
    selectInterventionRequired: "Seleccione un tipo de intervención",
    questionnairesLabel: "Cuestionarios",
    continueLabel: "Continuar",
    notifyPatientUpdatedDescription:
        "El modelo se ha añadido al diario. ¿Desea enviar un mensaje al paciente sobre esta actualización?",
    noJustFinish: "No, solo finalizar",
    yesNotifyPatient: "Sí, avisar al paciente",
    diaryUpdatedFromTemplate: "Diario actualizado desde el modelo",
    couldNotApplyTemplate: "No se ha podido aplicar el modelo",
    updateMessageTitle: "¿Enviar un mensaje al paciente?",
    updateMessageDescription: "Enviar un mensaje al paciente después de guardar.",
    noJustSave: "No, solo guardar",
    yesSendMessage: "Sí, enviar un mensaje",
    saveAndMessagePatient: "Guardar y escribir al paciente",
    saveOnly: "Guardar",
    updateQuestionnairesTitle: "Cuestionarios",
    updateQuestionnairesDescription: "Seleccione los cuestionarios y los calendarios de seguimiento",
    selectQuestionnaire: "Seleccionar un cuestionario",
    selectQuestionnaireHelp: "¿A qué preguntas debe responder el paciente?",
    selectSchedule: "Seleccionar un calendario",
    selectScheduleHelp: "¿Cuándo debe completar el cuestionario el paciente?",
    addAnotherQuestionnaire: "Añadir otro cuestionario",
    continueWithoutQuestionnaires: "Continuar sin cuestionarios",
    referenceDateTitle: "Fecha",
    referenceDateDescription: "Defina la fecha de inicio del tratamiento o del periodo de seguimiento.",
    contactStepDescription: "¿Quién es la persona de contacto?",
    questionnaireWithIndex: (index: number) => `Cuestionario ${index}`,
    setFlag: "Establecer estado",
    editStatus: "Editar estado",
    setFlagTitle: "Editar estado",
    setFlagDescription: "Esto sustituye el estado automático hasta que devuelva el diario al cálculo automático.",
    flagOnTrack: "En plazo",
    flagImproved: "Mejorado",
    flagWorsening: "Nuevo empeoramiento",
    flagNotImproving: "Ninguna mejoría",
    flagNoteLabel: "Nota",
    flagNotePlaceholder: "Nota interna opcional",
    saveFlag: "Guardar estado",
    resumeAutomatic: "Reanudar el estado automático",
    resumeAutomaticHint: "El estado se volverá a calcular a partir de las entradas del paciente.",
    setManually: "Establecido manualmente",
    setManuallyBy: (name) => `Establecido por ${name}`,
    teamRecordTitle: "Registro del equipo",
    teamRecordPrivate: "Solo visible para clínicos y administradores. Los pacientes nunca lo ven.",
    notesTitle: "Notas (no compartidas con el paciente)",
    notesDescription: "Notas internas (no compartidas con el paciente)",
    noteByline: (author, when) => `Por ${author} ${when}`,
    noteJustNow: "ahora",
    addNote: "Añadir nota",
    notePlaceholder: "Escriba una nota interna",
    saveNote: "Guardar nota",
    editNote: "Editar",
    addNoteName: "Añadir un nombre",
    noteNameLabel: "Nombre",
    saveNoteEdit: "Guardar",
    deleteNote: "Eliminar",
    deleteNoteTitle: "Eliminar nota",
    deleteNoteConfirm: "Esta nota se eliminará. Esta acción no se puede deshacer.",
    noteDeleted: "Nota eliminada",
    couldNotDeleteNote: "No se pudo eliminar la nota",
    cancelNoteEdit: "Cancelar",
    noteEdited: "Editada",
    statusChangedTo: "Estado cambiado a",
    statusSetVerb: "estableció",
    statusResumed: (name) => `${name} devolvió este diario al estado automático`,
    noTeamRecord: "Aún no hay cambios de estado.",
    couldNotSaveFlag: "No se pudo guardar el estado",
    couldNotSaveNote: "No se pudo guardar la nota",
    flagSaved: "Estado guardado",
    noteSaved: "Nota guardada",
};
